import { OperatorsTable } from "@/features/operators/operators-table";
import { CreateOperatorButton } from "@/features/operators/create-operator-button";

export function OperatorsScreen() {
  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">Operators</h1>
        <CreateOperatorButton />
      </div>
      <OperatorsTable />
    </div>
  );
}
